import { ENVIRONMENT_CONSTANT } from "./env.constant";

export const STRIPE_ONBOARDING_ENDPOINTS = {
    GET_ACCOUNT: `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/user/`,
    CREATE_ACCOUNT: `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/user/create`,
    DELETE_ACCOUNT: `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/user/delete`,
    GET_ONBOARDING_LINKS: `${process.env.REACT_APP_STRIPE_ENDPOINT}account_links`,
    ONBOARD_EXISTING_STRIPE_ACCOUNT: `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/onboard`,
    STRIPE_OAUTH_LINK: `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/redirect/oauth`
}